import { injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable } from 'mobx';
import { EstimateContainerType } from '../api/portal-dashboard.api';

@injectable()
export class ProposalDrawerStore {
    @observable proposalId?: string;
    @observable estimateContainerType?: EstimateContainerType;

    @computed get isOpen() {
        return !!this.proposalId;
    }

    @computed get isContract() {
        return this.estimateContainerType === EstimateContainerType.ContractProposal;
    }

    constructor() {
        makeObservable(this);
    }

    @action
    open = (proposalId: string, estimateContainerType?: EstimateContainerType) => {
        this.proposalId = proposalId;
        this.estimateContainerType = estimateContainerType;
    };

    @action
    close = () => {
        this.proposalId = undefined;
        this.estimateContainerType = undefined;
    };
}
